module.exports = __webpack_public_path__ + "static/media/default_group.dcc24b36.svg";